<template>
  <div>
    <el-button
      type="primary"
      @click="addCLassForStu"
      :size="btnSize"
      :disabled="btnDisable"
      icon="el-icon-edit"
    >
      <slot></slot>
    </el-button>
    <Modal v-model="modalShow" width="760" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>
          <slot></slot>
        </span>
      </p>
      <el-form :inline="true" :model="formStu" label-width="90px">
        <el-form-item label="修改积分:">
          <el-input
            v-model="formStu.score"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input
            v-model="formStu.remark"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
        <div style="color:#ccc;margin-left:20px">
          *修改积分时，输入+增加积分，输入-减少积分
        </div>
      </el-form>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 300px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "stuScore",
  data() {
    return {
      modalShow: false,
      loading: true,
      formStu: {
        remark: "",
        score: "",
      },
    };
  },
  props: {
    btnDisable: {
      type: Boolean,
      default: false,
    },
    btnSize: {
      type: String,
      default: "mini",
    },
  },
  created() {},
  watch: {},
  methods: {
    addCLassForStu() {
      this.modalShow = true;
    },

    modalConfirm() {
      if (this.formStu.score == "") {
        alert("积分不能为空");
        return;
      } else if (this.formStu.remark == "") {
        alert("备注不能为空");
        return;
      } else {
        //   传值
        this.$emit("stuScoreResult", {
          remark: this.formStu.remark,
          score: this.formStu.score,
        });

        this.modalShow = false;
      }
    },
    modalCancel() {
      this.modalShow = false;
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// stuScore.vue?2e6ec268